<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
           <b-img
            fluid
            :src="imgUrl"
            alt="logo"
            width="250"
          />
        </b-link>

        <b-card-title>
          Verifikasi Data Peserta!
        </b-card-title>
        <p>Aplikasi Pendaftaran {{ appName }} Universitas Indonesia </p>


        <!-- form -->
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- username -->
            <b-form-group
              label="Nama Lengkap"
              label-for="name"
            >
              <validation-provider
                #default="{ errors }"
                name="nama"
                rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
              >
                <b-form-input
                  id="nama"
                  v-model="nama"
                  :state="errors.length > 0 ? false:null"
                  name="nama"
                  placeholder="Isi Nama Anda"
                />
                <small class="text-danger">{{ errors[0] ? 'Silahkan isi Nama anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- email -->
            <b-form-group
              label="Email (Harus sama dengan Email di Sistem Enrollment UI)"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  :state="errors.length > 0 ? false : null"
                  name="register-email"
                  placeholder="email@example.com"
                  autocomplete="off"
                />
                  <small class="text-danger">{{ errors[0] ? 'Silahkan isi Email anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Nomor HP"
              label-for="nomor_hp"
            >
              <validation-provider
                #default="{ errors }"
                name="nomor_hp"
                rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
              >
                <b-form-input
                  id="nomor_hp"
                  v-model="nomor_hp"
                  :state="errors.length > 0 ? false : null"
                  name="nomor_hp"
                  placeholder="Nomor HP"
                  type="nomor_hp"
                />
                 <small class="text-danger">{{ errors[0] ? 'Silahkan isi Nomor HP anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Nomor Ujian  (Harus sama dengan Nomor Ujian di Sistem Enrollment UI)"
              label-for="Nomor Ujian"
            >
              <validation-provider
                #default="{ errors }"
                name="nomor_ujian"
                rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
              >
                <b-form-input
                  id="nomor_ujian"
                  v-model="nomor_ujian"
                  :state="errors.length > 0 ? false:null"
                  name="nomor_ujian"
                  placeholder="Nomor Ujian"
                  type="number"
                />
                 <small class="text-danger">{{ errors[0] ? 'Silahkan isi Nomor Ujian anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group
              label="Password"
              label-for="password"
            >
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    name="register-password"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="'EyeIcon'"
                      class="cursor-pointer"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                 <small class="text-danger">{{ errors[0] ? 'Password minimal 6 karakter' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="register-privacy-policy"
                v-model="status"
                name="checkbox-1"
              >
                Saya menyetujui
                <b-link>Syarat & Ketentuan</b-link>
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              :disabled="loading == 1"
              variant="primary"
              block
              type="submit"
            >
              <div v-if="loading == 0">
                Verifikasi Data
              </div>
              <div v-if="loading == 1">
                <b-spinner label="Spinning"></b-spinner>
              </div>
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <span>Sudah Verifikasi? </span>
          <b-link :to="{name:'auth-login'}">
            <span>Login di sini</span>
          </b-link>
        </b-card-text>
      </b-card>
    <!-- /Register v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  BCard, BLink, BCardTitle, BCardText, BForm,
  BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox, BImg, BSpinner,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  postRegister,
} from '@/connection-api/master'

export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
    BImg,
    vSelect,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      loading: 0,
      regEmail: '',
      nama: '',
      password: '',
      status: '',
      nomor_hp: null,
      nomor_ujian: null,
      register_as: '',

      // validation rules
      required,
      email,
      sideImg: require('@/assets/images/logo/logo.png'),
      registerSebagaiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Daftar Sebagai --' },
          { value: 'mahasiswa', title: 'Mahasiswa' },
          { value: 'dosen', title: 'Dosen' },
        ],
      },
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    validationForm() {
      this.loading = 1
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          var data = {
            nama: this.nama,
            password: this.password,
            email: this.email,
            nomor_hp: this.nomor_hp,
            nomor_ujian: this.nomor_ujian,
          }
          postRegister(data)
          .then(response => {
            if (response.data.status?.code === '00') {
               this.makeToast('success', 'Data berhasil didaftarkan, silahkan cek email untuk verifikasi OTP.')
               setTimeout(() => {
                this.loading = 0
                this.$router.push({name: 'auth-verifikasi', params: { email: this.email } })
               }, 3000);
            } else {
                this.loading = 0
               this.makeToast('danger', response.data.status?.message)
            }
          })
          .catch(error => console.log(error));
        }
      })
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Register',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
